<template>
	<div v-show="active" class="remind-box flex-center">
		<div class="remind-dialog flex-column">
			<h1>到期提醒</h1>
			<p class="flex-grow">您好！贵公司购买的蜂鸟工系统<span v-if="freeEdition">【免费版】</span><span v-else style="color: #FF0000;">【专业版】</span>使用期限<span style="font-weight: bold; color: #FF0000;">仅剩{{saasInfo.remaining_effective_days}}天</span>，到期时间截止{{saasInfo.auth_exp_date.replace('-', '年').replace('-', '月')}}日，为避免影响您的正常使用，请及时续期。</p>
			<div class="flex button-box">
				<div class="button" @click="active = false">我知道了</div>
				<div class="button flex-grow" @click="active = false; $emit('resolve');">我要续期</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		data() {
			return {
				active: false
			}
		},

		computed: {
			...mapState(['saasInfo']),
			...mapGetters(['freeEdition'])
		},
		
		methods: {
			open() {
				let date = new Date().format('yyyy-MM-dd');
				if (localStorage.getItem('renewRemind') != date) {
					localStorage.setItem('renewRemind', date);
					this.active = true;
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@keyframes guideIn {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}

	@keyframes guideTipIn {
		0% {
			opacity: 0;
			transform: translate(40px,0);
		}

		100% {
			opacity: 1;
			transform: translate(0,0);
		}
	}

	.remind {
		&-box {
			z-index: 9999;
			position: fixed;
			inset: 0;
			background: rgba(0,0,0,.8);
			animation: guideIn .4s;
		}

		&-dialog {
			position: relative;
			box-sizing: border-box;
			width: 500px;
			height: 350px;
			border-radius: 12px;
			padding: 0 25px 25px;
			background-color: #fff;
			background-image: url('~@/assets/image/renew_bg.jpg');
			background-size: 100% auto;
			background-repeat: no-repeat;

			&:before {
				content: '';
				position: absolute;
				right: 12px;
				top: -30px;
				width: 120px;
				height: 120px;
				background-image: url('~@/assets/image/renew_img.png');
				background-size: 100%;
			}

			h1 {
				line-height: 110px;
				font-size: 26px;
				font-weight: bold;
				color: var(--color-main);
			}

			p {
				line-height: 30px;
				font-size: 18px;
			}

			.button {
				box-sizing: border-box;
				width: 120px;
				border: 1px solid #ccc;
				border-radius: 6px;
				line-height: 48px;
				font-size: 18px;
				text-align: center;
				color: #666;
				cursor: pointer;

				&:hover {
					border-color: #999;
					color: #333;
				}

				&:nth-child(2) {
					border-color: var(--color-main);
					color: #fff;
					background: var(--color-main);

					&:hover {
						border-color: var(--color-main-hover);
						background: var(--color-main-hover);
					}
				}

				&-box {
					gap: 15px;
				}
			}
		}
	}
</style>
